<template>
    <card>
            <template slot="header">
                <h3 class="card-title">Change Password</h3>
            </template>
            <nav class="row">
                <ol class="breadcrumb arr-right bg-breadcrum">
                   <li class="breadcrumb-item">
                      <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                   </li>
                     <li class="breadcrumb-item active">Change Password</li>
                     <li class="breadcrumb-item">
                       <router-link to="creditconfig"></i>&nbsp;Leave Credit Config </router-link>
                    </li>
                     <li class="breadcrumb-item">
                       <router-link to="notificationconfig"></i>&nbsp;Notification Config </router-link>
                    </li>
                </ol>
             </nav>
             <hr style="margin-top:-10px"/>
             <form @submit="formSubmit">
                <div class="row">
                   <div class="col-md-12">
                      <div class="row">
                         <div class="col-md-4">
                            <div class="form-group"> 
                               <p class="p-text"> Current Password :</p>
                               <input type="password" v-model="current_password" class="form-control" autocomplete="off">
                                 <!-- <span v-if="error_handler.current_password" class="invalid-feedback">{{ error_handler.current_password[0] }}</span> -->
                            </div>
                            <div class="form-group"> 
                                <p class="p-text"> New Password :</p>
                                <input type="password" v-model="new_password" class="form-control" autocomplete="off">
                                   <!-- <span v-if="error_handler.new_password" class="invalid-feedback">{{ error_handler.new_password[0] }}</span> -->
                             </div>
                             <div class="form-group"> 
                                <p class="p-text"> Confirm Password :</p>
                                <input type="password" v-model="confirm_password" class="form-control" autocomplete="off">
                                  <!-- <span v-if="error_handler.confirm_password" class="invalid-feedback">{{ error_handler.confirm_password[0] }}</span> -->
                             </div>
                         </div>
                      </div>
                      <br/>
                      <button class="btn btn-info"><i class="fa fa-save"></i>&nbsp;Change Password</button> 
                      <br/> <br/>
                   </div>
                </div>
             </form>
    </card>		
</template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    components: {
        Card
    },
    data(){
        return{
            current_password:'',
            new_password:'',
            confirm_password:'',
            error_handler:[],
            message:''
        }
        },
    created:function () {
     
    },    
    methods:{
  
        formSubmit(e){
             e.preventDefault();
             this.$swal({
                     title: 'Are you sure?',
                     text: 'Do you want to change your password',
                     type: 'warning',
                     showCancelButton: true,
                     showCloseButton: false,
                   })
              .then((isConfirm) => {
                   if(isConfirm === true) {
        
                        axios.post('api/login/pwdchange',{
                        current_password:this.current_password,
                        new_password:this.new_password,
                        confirm_password:this.confirm_password
                                       
                     })
                       .then(resp=> {                      
                              //  this.$swal('Changed', 'Your password has been changed successfully. Please try to login to confirm.' , 'success')
                             
                                this.$swal({
                                    type: 'success',
                                    title: 'Changed',
                                    text: 'Your password has been changed successfully. Please try to login to confirm.',
                                    showConfirmButton: false,
                                    timer: 4000
                               })
                             
                                this.$router.push({name: 'Logout-Layout'}) 
      
                           })    
                           .catch(error => {
                                if (error.response.status == 422){
                                    this.error_handler = error.response.data.message
                                    this.$swal('Opps', this.error_handler, 'error');
                                    console.log(this.error_handler)
                                 }
                           }); 
                      }
                  }); 
         },
    }
}
</script>
<style>
      .bg-breadcrum{
        background:#fff;
     }
     .p-text{
         color:#666;
     }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-settings/todo-settings.vue